import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Meta Tags Component
 * Optimized for search engines and social media sharing
 */
const SEOMetaTags = ({
  title,
  description,
  keywords = [],
  image,
  url,
  type = 'website',
  author,
  publishedTime,
  modifiedTime,
  structuredData,
}) => {
  const fullTitle = title ? `${title} | MindWell - Find Mental Health Professionals` : 'MindWell - Find Verified Mental Health Professionals';
  const defaultDescription = 'Find verified psychiatrists, psychologists, therapists, and counselors. Book appointments online. Get professional mental health care from trusted professionals in India and worldwide.';
  const metaDescription = description || defaultDescription;
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://mindwell.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const defaultImage = image || `${siteUrl}/images/mindwell-og-image.jpg`;
  const keywordsString = Array.isArray(keywords) ? keywords.join(', ') : keywords || 'mental health, psychiatrist, psychologist, therapist, counselor, online therapy, appointment booking';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={keywordsString} />
      {author && <meta name="author" content={author} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={defaultImage} />
      <meta property="og:site_name" content="MindWell" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={defaultImage} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Structured Data (JSON-LD) - Support for arrays of schemas */}
      {structuredData && (
        <>
          {Array.isArray(structuredData) ? (
            structuredData.map((schema, index) => (
              <script key={index} type="application/ld+json">
                {JSON.stringify(schema)}
              </script>
            ))
          ) : (
            <script type="application/ld+json">
              {JSON.stringify(structuredData)}
            </script>
          )}
        </>
      )}
    </Helmet>
  );
};

export default SEOMetaTags;

